module.exports = __webpack_public_path__ + "img/examenes-autodesk.9cc18526.png";